import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Card from '../../../../common/card';
import WithQriosBackground from '../../../../common/qrios-background/withQriosBackground';
import PageContent from './pageContent';
import { PORTAL_PATH, PROFILE_CREATION_PATH } from '../../../../routes/paths';
import { useInvitationConfirm } from './useInvitationConfirm';
import { Dialog } from '../../../../common/dialog';
import DialogContent from './dialogContent';
import { ClientStatusContext } from '../../../../common/client-status';
import { CLIENT_STATUS } from '../../../../common/client-status/interfaces';

const ProfileInvitation = () => {
  const history = useHistory();
  const { getClientStatus } = useContext(ClientStatusContext);

  const { isDialogOpen, loading, handleOpenDialog, closeDialog, error, handleConfirmation } = useInvitationConfirm({
    handleSuccess: () => {
      getClientStatus({
        onSuccess: (status: CLIENT_STATUS) => {
          if (status === 'CLIENT_PROFILE_ACTIVE') {
            history.push(PORTAL_PATH.DASHBOARD);
          }
        },
        onFailure: () => {}
      });
    }
  });

  const handleNoOption = () => {
    history.push(PROFILE_CREATION_PATH.PROFILE_CREATION);
  };

  const handleYesOption = () => {
    handleOpenDialog();
  };

  return (
    <WithQriosBackground title="Get started with Qrios">
      <Card
        content={
          <PageContent
            status="enabled"
            handleCancel={handleNoOption}
            submitHandler={handleYesOption}
            title="Select registration option"
          />
        }
      />
      <Dialog
        open={isDialogOpen}
        handleClose={closeDialog}
        title="Provide invitation code which was send to your email"
      >
        <DialogContent
          loading={loading}
          error={error}
          handleSubmitAction={handleConfirmation}
          handleCloseDialog={closeDialog}
        />
      </Dialog>
    </WithQriosBackground>
  );
};

export default ProfileInvitation;
